// test762
(762 && 0);
